export default {
	init() {
        
		const ourTeamBlocks = document.querySelectorAll('.flip-our-team-block');
		if (!ourTeamBlocks.length) return;

		const setBodyOverflow = (value) => {
			document.body.style.overflow = value;
		};

		ourTeamBlocks.forEach((block) => {
			const categoryItems = block.querySelectorAll('.flip-our-team__categories-list li');
			const memberItems = block.querySelectorAll('.flip-our-team__members-item .readmore');

			const mobileContainer = block.querySelector('.flip-our-team__categories__mobile');
			const mobileLabel = block.querySelector('.flip-our-team__categories__mobile--label');
			const mobileDropdown = block.querySelector('.flip-our-team__categories__mobile-list');
			const mobileItems = block.querySelectorAll('.flip-our-team__categories__mobile-list li');

			const modal = block.querySelector('.aura-modal-team-member');
			categoryItems.forEach((item) => {
				item.addEventListener('click', () => {
					const tabId = item.dataset.tab;
					block.querySelectorAll('.flip-our-team__categories-list li').forEach((el) => {
						el.classList.remove('active');
					});
					item.classList.add('active');
					block.querySelectorAll('.flip-our-team__members-inner').forEach((el) => {
						el.classList.remove('active');
					});
					const targetTab = tabId ? block.querySelector(`#${CSS.escape(tabId)}`) : null;
					if (targetTab) targetTab.classList.add('active');
				});
			});
			memberItems.forEach((trigger) => {
				trigger.addEventListener('click', (e) => {
					e.preventDefault();
					const memberItem = trigger.closest('.flip-our-team__members-item');
					if (!memberItem) return;
					const aboutMember = memberItem.querySelector('.about-member')?.innerHTML || '';
					const name = memberItem.querySelector('h6')?.textContent || '';
					const position = memberItem.querySelector('.position')?.textContent || '';
					const image = memberItem.querySelector('.flip-our-team__members-image img')?.getAttribute('src') || '';
					const desc = block.querySelector('.aura-modal-team-member__right-desc');
					if (desc) desc.innerHTML = aboutMember;
					const positionEl = block.querySelector('.aura-modal-team-member__right-position');
					if (positionEl) positionEl.textContent = position;
					const nameEl = block.querySelector('.aura-modal-team-member__right-name');
					if (nameEl) nameEl.textContent = name;
					const avatarImg = block.querySelector('.aura-modal-team-member__left-avatar img');
					if (avatarImg) avatarImg.setAttribute('src', image);
					block.classList.add('show');
					setBodyOverflow('hidden');
				});
			});
			if (modal) {
				modal.addEventListener('click', (e) => {
					const isBackdropClick = e.target === modal;
					const isCloseClick = e.target.closest('.aura-close-modal');
					if (!isBackdropClick && !isCloseClick) return;
					block.classList.remove('show');
					setBodyOverflow('');
				});
			}

			if (mobileLabel && mobileDropdown) {
				
				mobileLabel.addEventListener("click", (e) => {
					e.stopPropagation();

					mobileDropdown.classList.toggle("open");
					mobileLabel.classList.toggle("active");
				});

				// click outside closes
				document.addEventListener("click", (e) => {
					if (!mobileContainer.contains(e.target)) {
						mobileDropdown.classList.remove("open");
						mobileLabel.classList.remove("active");
					}
				});
			}

			if ( mobileItems ){
				mobileItems.forEach((item) => {
					item.addEventListener("click", () => {
					const tabId = item.dataset.tab;

					// update label text
					if (mobileLabel) {
						mobileLabel.childNodes[0].nodeValue = item.textContent.trim() + " ";
					}

					block.querySelectorAll('.flip-our-team__members-inner').forEach((el) => {
						el.classList.remove('active');
					});

					const targetTab = tabId ? block.querySelector(`#${CSS.escape(tabId)}`) : null;
					if (targetTab) targetTab.classList.add('active');

					categoryItems.forEach((el) => el.classList.remove('active'));
					const matched = [...categoryItems].find(el => el.dataset.tab === tabId);
					if (matched) matched.classList.add('active');

					mobileDropdown.classList.remove("open");
					mobileLabel.classList.remove("active");
					});
				});
			}

		});

	}
};